import { defineComponent as a, computed as o, openBlock as i, createElementBlock as c, createElementVNode as e, toDisplayString as d, createCommentVNode as h, normalizeStyle as _ } from "vue";
const f = ["viewBox"], v = /* @__PURE__ */ e("mask", { id: "f6a1bdfd-b166-4317-8ec0-62015abe71b4" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#f6a1bdfd-b166-4317-8ec0-62015abe71b4)" }, m = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M0 47.2 47.2 0h175.4L256 27.3 289.4 0H465l47 47.3v175.3l-24.2 35.2 24.2 31.6v175.4L464.8 512H289.4l-32-26.4-34.8 26.4H47.2L0 464.8V289.4L25 257 0 222.6z"
}, null, -1), k = /* @__PURE__ */ e("path", {
  fill: "#496e2d",
  d: "M0 0v47.2L208.8 256 0 464.8V512h47.2L256 303.2 464.8 512H512v-47.2L303.2 256 512 47.3V0h-47L256 208.8 47.2 0H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M222.6 0v222.6H0v66.8h222.6V512h66.8V289.4H512v-66.8H289.4V0h-66.8z"
}, null, -1), b = { fill: "none" }, x = ["r"], w = /* @__PURE__ */ a({
  __name: "es-pv",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const t = r, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), n = o(() => 256 + t.strokeWidth / 2);
    return (H, L) => (i(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      v,
      e("g", u, [
        t.flagName ? (i(), c("title", m, d(t.flagName), 1)) : h("", !0),
        p,
        k,
        g
      ]),
      e("g", b, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: _({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, f));
  }
});
export {
  w as default
};
//# sourceMappingURL=es-pv-cdbd05a3.js.map
